import { Box, Center, Heading, Link } from '@hover/blueprint';
import React from 'react';
import { animated, useSpring } from 'react-spring';

import { BackgroundLogo } from 'src/modules/designStudio/components/BackgroundLogo';
import { animationConfig } from 'src/modules/designStudio/helpers/animationConfig';
import { Button } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { External } from 'src/shared/route';

export const InteractiveRenderingErrorPage = () => {
  const props = useSpring(animationConfig.loaderAnimation);

  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  return (
    <Box
      alignItems="center"
      backgroundColor="primary.base"
      bottom={0}
      flex={1}
      justifyContent="center"
      left={0}
      overflow="hidden"
      paddingX={400}
      position="absolute"
      right={0}
      top={0}
    >
      <BackgroundLogo />
      <animated.div style={props}>
        <Heading color="neutral.0" textAlign="center">
          {t('interactiveRenderings.somethingIsWrong')}
        </Heading>
        <Heading
          color="neutral.0"
          size={400}
          sx={{ marginBottom: 500 }}
          textAlign="center"
        >
          {t('interactiveRenderings.reachOut')}
        </Heading>
        <Center>
          <Link href={External.CONTACT.path} isMinimal>
            <Button
              fill="outline"
              shape="box"
              size="large"
              sx={{ backgroundColor: 'neutral.0' }}
            >
              {t('interactiveRenderings.getInTouch')}
            </Button>
          </Link>
        </Center>
      </animated.div>
    </Box>
  );
};
